import React from 'react';
import { Tabs } from '../../../components/Tabs';
import Redeem from './Redeem';
import History from './History';
import { CouponEntry, CouponType, Tabbar } from '../../../models/common/common';
import { useInitialCofig } from '../../../hooks/initialConfig-hook';
import { useCustomerData } from '../../../hooks/customer-hook';
import MyCoupon from './MyCoupon';
import { Coupon as CouponModel } from '../../../models/coupon';
import Promotion from './Promotion';
import { useCoupon } from '../../../hooks/coupon-hook';
import { initialStore } from '../../../stores/init_config_store';
import { CouponHistory, MyCouponType } from '../../../models/dto/entry';
import { get_coupon_entry } from '../../../apis/api';

//AVCDAAV.002  20/03/2025  Add code for Adding coupon page

const Coupon = () => {
    const [active, setActive] = React.useState<Tabbar>("promotion");
    const { coupons, loading } = useCoupon();
    const [couponRedeem, setCouponRedeem] = React.useState<CouponModel[]>();
    const [couponPromotion, setCouponPromotion] = React.useState<CouponModel[]>();
    const { initialConfig } = useInitialCofig();
    //AVCDAPNF.0001  29/04/2025  Add code for ... Make reuse logo image
    const logo = initialStore((state) => state.logo);
    //C-AVCDAPNF.0001  29/04/2025  Add code for ... Make reuse logo image
    const { customer } = useCustomerData();
    const [couponHistoy, setCouponHistory] = React.useState<CouponHistory[]>();
    const [myCoupon, setMyCoupon] = React.useState<MyCouponType[]>();

    React.useEffect(() => {
        setShowCouponWithCondition();
        setCouponEntry();
    }, [coupons, customer]);

    async function setShowCouponWithCondition() {
        if (coupons && coupons.length > 0 && customer) {
            const now: number = Date.now();
            const couponFilter = coupons.filter((coupon) => {
                let startDateArrived = true
                if (coupon.startingDate !== "") {
                    const start = coupon.startingDate.split("/");
                    let formatStartDate = coupon.startingDate;
                    if (start.length > 0) {
                        formatStartDate = `${start[1]}/${start[0]}/${start[2]}`;
                    }
                    const startDate: Date = new Date(formatStartDate);
                    const startDateTimestamp: number = startDate.getTime();
                    startDateArrived = (now - startDateTimestamp) >= 0;
                }

                let endDateNotPassedYet = true;
                if (coupon.endingDate !== "") {
                    const end = coupon.endingDate.split("/");
                    let formatEndDate = coupon.endingDate;
                    if (end.length > 0) {
                        formatEndDate = `${end[1]}/${end[0]}/${end[2]}`;
                    }
                    const endDate: Date = new Date(formatEndDate);
                    endDate.setDate(endDate.getDate() + 1);
                    const endDateTimestamp: number = endDate.getTime() - 1000;
                    endDateNotPassedYet = endDateTimestamp - now > 0;
                }

                let validMemberScheme = true;
                if (coupon.memberScheme !== "") {
                    validMemberScheme = customer.scheme === coupon.memberScheme;
                }
                
                let validMemberClub = true;
                if (coupon.memberClub !== "") {
                    validMemberClub = customer.club_code === coupon.memberClub;
                }

                if (startDateArrived && endDateNotPassedYet && validMemberScheme && validMemberClub) {
                    return coupon;
                }
            });
            const redeemCoupon = couponFilter.filter((coupon) => coupon.type === CouponType.REDEEM || coupon.type === 1 );
            const promotionCoupon = couponFilter.filter(coupon => coupon.type === CouponType.PROMOTION || coupon.type === 2 );
            setCouponRedeem(redeemCoupon);
            setCouponPromotion(promotionCoupon);
        }
    }

    async function setCouponEntry() {
        try {
            if (customer) {
                const response = await get_coupon_entry({ club: customer.club_code, accountNo: customer.bc_account_no });
                const history = response.filter((en) => en.status === CouponEntry.APPLIED);
                const myCoupon = response.filter((en) => en.status === CouponEntry.OPEN);
                setCouponHistory(history);
                setMyCoupon(myCoupon);
            }
        } catch (error) {
            console.log(`Get Coupon History Error: ${error}`);
        }
    }

    const tabs: { key: Tabbar, name: string }[] = [
        { key: "promotion",name: "Promotion"}, 
        { key: "redeem_point",name: "Redeem" }, 
        { key: "my_coupon",name: "My Coupon"}, 
        { key: "history",name: "History"} 
    ]

    return (
        <React.Fragment>
            <div className='card card-homepage main-custom-container' >
                <div className='row mb-8 imagelogo' style={initialConfig.styles.background_Style} >
                    <img className='logo' src={logo} />
                </div>
                <Tabs setActiveIndex={setActive} active={active} tabs={tabs}/>
                {active === "redeem_point" && (
                    <Redeem customerData={customer} couponRedeem={couponRedeem} loading={loading} />
                )}
                {active === "promotion" && (
                    <Promotion customerData={customer} couponPromotion={couponPromotion} loading={loading} />
                )}
                {active === "history" && (
                    <History couponHistory={couponHistoy} />
                )}
                {active === "my_coupon" && (
                    <MyCoupon myCoupon={myCoupon} />
                )}
            </div>
        </React.Fragment>
    );
};

export default Coupon;

//C-AVCDAAV.002  20/03/2025  Add code for Adding coupon page